import { Button } from '@/components/ui/button'
import type { ConnectionTest } from '@/features/settings/types'

/**
 * A settings part's connection test: the button, and what the last test said — a failure as an
 * alert, anything else as a status. Shared by the audio and the video engine sections.
 */
export function ConnectionTestRow({
  id,
  result,
  testing,
  onTest,
  labels,
}: {
  id: string
  result: ConnectionTest | null
  testing: boolean
  onTest: () => void
  /** Translated: the button's text and what it says while the test runs. */
  labels: { test: string; working: string }
}) {
  const message = testing ? labels.working : result?.message
  const failed = !testing && result?.ok === false
  return (
    <div className="flex items-center gap-3">
      <Button
        type="button"
        variant="outline"
        aria-describedby={message ? `${id}-test-status` : undefined}
        onClick={onTest}
      >
        {labels.test}
      </Button>
      {message && (
        <p
          id={`${id}-test-status`}
          role={failed ? 'alert' : 'status'}
          className={`min-w-0 flex-1 text-sm ${failed ? 'text-destructive' : 'text-muted-foreground'}`}
        >
          {message}
        </p>
      )}
    </div>
  )
}
